import{HelgaSectionTitle}from"@joinbox/helga-animations";HelgaSectionTitle.defineCustomComponent();